import moment from 'moment'
import { connect } from 'react-redux'
import { Timescale } from '@opallabs/concepts'
import { actions } from '@opallabs/wormhole'
import StoryExport from '.'

const ExportToCSVComponent = (props) => <StoryExport {...props} />

const mapStateToProps = (state) => ({
  filterProps: state.filters || {},
  rowCount: state.storyCSVRowCount || 0,
  stories: state.stories,
  workspaceId: state.current_workspace_id,
  startDate: moment(),
  duration: Timescale.Year,
})

const mapDispatchToProps = (dispatch) => ({
  getRowCount: (params) => {
    const countParams = { ...params, ...params.filterAttributes }
    dispatch(actions.getStoryCSVRowCount(countParams))
  },
  getStories: (workspaceId) => {
    dispatch(actions.getStoriesV2(workspaceId))
  },
  createCSV: (params) => {
    const postParams = {
      ...params,
      ...params.filterAttributes,
    }
    dispatch(actions.createCSV(postParams))
  },
  loadFilters: (params) => {
    dispatch(
      actions.loadFilters({
        filterTree: params.filterTree,
        value: params.value,
        disabledValues: params.disabledValues,
        filterValues: params.filterValues,
      })
    )
  },
})

const ConnectedStoryExport = connect(
  mapStateToProps,
  mapDispatchToProps
)(ExportToCSVComponent)

export default ConnectedStoryExport
